
    (function () {

      // ─── SessionStorage ─────────────────────────────────────────────────────────

      function getStoredPath() {
        try { return JSON.parse(sessionStorage.getItem('collection_path') || '[]'); }
        catch (e) { return []; }
      }

      function setStoredPath(path) {
        sessionStorage.setItem('collection_path', JSON.stringify(path));
      }

      function clearStoredPath() {
        sessionStorage.removeItem('collection_path');
      }

      // ─── URL Helpers ─────────────────────────────────────────────────────────────

      function getCollectionHandle(urlOrPath) {
        try {
          var m = new URL(urlOrPath, window.location.origin).pathname.match(/^\/collections\/([^\/\?#]+)/);
          return m ? m[1] : null;
        } catch (e) { return null; }
      }

      function isHomePage() {
        var p = window.location.pathname;
        return p === '/' || p === '/index.html';
      }

      // ─── Path Management ─────────────────────────────────────────────────────────

      function normalizeCurrentCollection() {
        if (isHomePage()) { clearStoredPath(); return; }
        var h = getCollectionHandle(window.location.href);
        if (!h) return;
        var path = getStoredPath();
        var i = path.indexOf(h);
        setStoredPath(i !== -1 ? path.slice(0, i + 1) : path.concat(h));
      }

      function updatePathForClick(h) {
        if (!h) return;
        var path = getStoredPath();
        var i = path.indexOf(h);
        setStoredPath(i !== -1 ? path.slice(0, i + 1) : path.concat(h));
      }

      // ─── Branch Helpers ───────────────────────────────────────────────────────────

      function parseBranches(els) {
        return els.map(function (el) {
          return { el: el, chain: (el.getAttribute('data-chain') || '').split('|||').filter(Boolean) };
        });
      }

      function filterByEndHandle(parsed, handle) {
        return parsed.filter(function (b) { return b.chain[b.chain.length - 1] === handle; });
      }

      function findDirectParentMatch(parsed, currentHandle, previousHandle) {
        if (!previousHandle) return null;
        for (var i = 0; i < parsed.length; i++) {
          var c = parsed[i].chain;
          if (c[c.length - 1] === currentHandle && c[c.length - 2] === previousHandle) return parsed[i];
        }
        return null;
      }

      function isFullMatch(chain, path) {
        for (var i = 0; i < chain.length; i++) {
          if (path.indexOf(chain[i]) === -1) return false;
        }
        return true;
      }

      function getCommonSuffixStart(parsed, currentHandle) {
        var chains = filterByEndHandle(parsed, currentHandle).map(function (b) { return b.chain; });
        if (!chains.length) return null;
        if (chains.length === 1) return chains[0][0];
        var minLen = chains.reduce(function (m, c) { return Math.min(m, c.length); }, Infinity);
        var result = null;
        for (var d = 1; d <= minLen; d++) {
          var h = chains[0][chains[0].length - d];
          if (chains.every(function (c) { return c[c.length - d] === h; })) result = h;
          else break;
        }
        return result;
      }

      // ─── Rendering ───────────────────────────────────────────────────────────────

      function trimToHandle(activeContainer, startHandle) {
        if (!startHandle) return;
        var nodes = activeContainer.querySelectorAll('.breadcrumb-collection');
        var startIdx = -1;
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].getAttribute('data-handle') === startHandle) { startIdx = i; break; }
        }
        if (startIdx <= 0) return;
        for (var j = 0; j < startIdx; j++) {
          var prev = nodes[j].previousElementSibling;
          if (prev && prev.classList.contains('breadcrumb-separator')) activeContainer.removeChild(prev);
          activeContainer.removeChild(nodes[j]);
        }
      }

      function finalizeLastCrumb(activeContainer, hasTrailing) {
        if (hasTrailing) return;
        var nodes = activeContainer.querySelectorAll('.breadcrumb-collection');
        if (!nodes.length) return;
        var last = nodes[nodes.length - 1];
        var link = last.querySelector('a');
        if (link) last.textContent = link.textContent;
        last.setAttribute('aria-current', 'page');
      }

      function renderTitleOnly(activeContainer, title) {
        activeContainer.innerHTML = '';
        var sep = document.createElement('span');
        sep.className = 'separator breadcrumb-separator';
        sep.setAttribute('aria-hidden', 'true');
        var crumb = document.createElement('span');
        crumb.className = 'breadcrumb-collection';
        crumb.setAttribute('aria-current', 'page');
        crumb.textContent = title;
        activeContainer.appendChild(sep);
        activeContainer.appendChild(crumb);
      }

      function renderAnchorOnly(activeContainer, anchorBranch) {
        var nodes = anchorBranch.el.querySelectorAll('.breadcrumb-collection');
        var anchorNode = nodes[nodes.length - 1];
        var anchorLink = anchorNode && anchorNode.querySelector('a');
        activeContainer.innerHTML = '';
        var sep = document.createElement('span');
        sep.className = 'separator breadcrumb-separator';
        sep.setAttribute('aria-hidden', 'true');
        var crumb = document.createElement('span');
        crumb.className = 'breadcrumb-collection';
        if (anchorLink) {
          var a = document.createElement('a');
          a.href = anchorLink.href;
          a.textContent = anchorLink.textContent;
          crumb.appendChild(a);
        } else {
          crumb.textContent = anchorNode ? anchorNode.textContent : '';
        }
        activeContainer.appendChild(sep);
        activeContainer.appendChild(crumb);
      }

      /**
      * Core logic shared by collection + product rendering.
      * Cases:
      * 1. 1 branch → use fully
      * 2. Multiple + previous is direct parent + full match → use fully
      * 3. Multiple + previous is direct parent + partial match → trim to deeper of (direct parent, common suffix)
      * 4. Multiple + no direct parent match → trim to common suffix, or title/anchor-only if none
      */
      function applyBranches(parsed, currentHandle, storedPath, previousHandle, activeContainer, hasTrailing, fallbackTitle, isProduct) {
        if (parsed.length === 1) {
          activeContainer.innerHTML = parsed[0].el.innerHTML;
          if (!isProduct) finalizeLastCrumb(activeContainer, hasTrailing);
          return;
        }

        var commonStart = getCommonSuffixStart(parsed, currentHandle);
        var match = findDirectParentMatch(parsed, currentHandle, previousHandle);

        if (match) {
          activeContainer.innerHTML = match.el.innerHTML;
          if (isFullMatch(match.chain, storedPath)) {
            if (!isProduct) finalizeLastCrumb(activeContainer, hasTrailing);
          } else {
            var directParent = match.chain[match.chain.length - 2] || null;
            var trimHandle = commonStart;
            if (directParent && commonStart) {
              var di = match.chain.indexOf(directParent);
              var ci = match.chain.indexOf(commonStart);
              trimHandle = di >= ci ? directParent : commonStart;
            } else {
              trimHandle = directParent || commonStart;
            }
            trimToHandle(activeContainer, trimHandle);
            if (!isProduct) finalizeLastCrumb(activeContainer, hasTrailing);
          }
        } else {
          if (commonStart) {
            activeContainer.innerHTML = parsed[0].el.innerHTML;
            trimToHandle(activeContainer, commonStart);
            if (!isProduct) finalizeLastCrumb(activeContainer, hasTrailing);
          } else {
            if (isProduct) renderAnchorOnly(activeContainer, parsed[0]);
            else renderTitleOnly(activeContainer, fallbackTitle);
          }
        }
      }

      // ─── Collection Breadcrumb ────────────────────────────────────────────────────

      function renderBreadcrumbBranch() {
        var root = document.querySelector('.js-breadcrumbs');
        if (!root) return;
        var currentHandle = root.getAttribute('data-current-handle');
        if (!currentHandle) return;
        var branchContainer = root.querySelector('.js-breadcrumb-branches');
        var activeContainer = root.querySelector('.js-breadcrumb-active-branch');
        if (!branchContainer || !activeContainer) return;
        var raw = branchContainer.querySelectorAll('.js-breadcrumb-branch');
        if (!raw.length) return;

        normalizeCurrentCollection();

        var parsed = filterByEndHandle(parseBranches(Array.prototype.slice.call(raw)), currentHandle);
        if (!parsed.length) return;

        var storedPath = getStoredPath();
        var ci = storedPath.lastIndexOf(currentHandle);
        var previousHandle = ci > 0 ? storedPath[ci - 1] : null;

        applyBranches(parsed, currentHandle, storedPath, previousHandle, activeContainer,
          root.getAttribute('data-has-trailing') === 'true',
          root.getAttribute('data-collection-title') || '',
          false);
      }

      // ─── Click Handling ───────────────────────────────────────────────────────────

      function handleCollectionNavigationEvent(e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.getAttribute('href');
        if (!href) return;
        var url;
        try { url = new URL(href, window.location.origin); } catch (e) { return; }
        if (url.pathname === '/' || url.pathname === '/index.html') { clearStoredPath(); return; }
        var h = getCollectionHandle(url.href);
        if (h) updatePathForClick(h);
      }

      // ─── Product Breadcrumb ───────────────────────────────────────────────────────

      function appendProductCrumb(activeContainer, title) {
        var sep = document.createElement('span');
        sep.className = 'separator breadcrumb-separator';
        sep.setAttribute('aria-hidden', 'true');
        var crumb = document.createElement('span');
        crumb.className = 'breadcrumb-product';
        crumb.setAttribute('aria-current', 'page');
        crumb.textContent = title;
        activeContainer.appendChild(sep);
        activeContainer.appendChild(crumb);
      }

      function renderProductBreadcrumb() {
        var root = document.querySelector('.js-breadcrumbs-product');
        if (!root) return;
        var productTitle = root.getAttribute('data-product-title');
        var validHandles = (root.getAttribute('data-valid-handles') || '').split('|||').filter(Boolean);
        if (!validHandles.length) return;
        var branchContainer = root.querySelector('.js-breadcrumb-branches');
        var activeContainer = root.querySelector('.js-breadcrumb-active-branch');
        if (!branchContainer || !activeContainer) return;
        var raw = Array.prototype.slice.call(branchContainer.querySelectorAll('.js-breadcrumb-branch'));
        if (!raw.length) return;

        var storedPath = getStoredPath();
        var anchorHandle = null;
        for (var i = storedPath.length - 1; i >= 0; i--) {
          if (validHandles.indexOf(storedPath[i]) !== -1) { anchorHandle = storedPath[i]; break; }
        }

        if (anchorHandle) {
          var parsed = filterByEndHandle(parseBranches(raw), anchorHandle);
          if (parsed.length) {
            var ai = storedPath.lastIndexOf(anchorHandle);
            var previousHandle = ai > 0 ? storedPath[ai - 1] : null;
            applyBranches(parsed, anchorHandle, storedPath, previousHandle, activeContainer, true, '', true);
          }
        }

        if (productTitle) appendProductCrumb(activeContainer, productTitle);
      }

      // ─── Init ─────────────────────────────────────────────────────────────────────

      if (document.querySelector('.js-breadcrumbs')) {
        renderBreadcrumbBranch();
        document.addEventListener('click', handleCollectionNavigationEvent);
      } else if (document.querySelector('.js-breadcrumbs-product')) {
        renderProductBreadcrumb();
      }

    })();
  